import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark } from "@fortawesome/free-solid-svg-icons";
import logo from "../images/logo.png";

import {
  Button,
  Container,
  Spinner,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

import RecapResa from "./RecapResa";

export default function LinkResa() {
  const navigate = useNavigate();
  const location = useLocation();

  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);

  const [toast, setToast] = useState({
    show: false,
    variant: "danger",
    message: "",
  });

  const token = "1654551514hhgfhfb45665454";

  // Id depuis l’URL:
  // Tu avais substring(18). Je sécurise pour éviter les bugs si le path change.
  const reservationId = useMemo(() => {
    // Exemple attendu: "/consultation-reservation/<ID>" ou "/link-reservation/<ID>"
    // On prend le dernier segment non vide.
    const parts = (location.pathname || "").split("/").filter(Boolean);
    return parts[parts.length - 1] || "";
  }, [location.pathname]);

  const goHome = () => navigate("/");

  const showToast = (variant, message) => {
    setToast({ show: true, variant, message });
  };

  async function getReservation() {
    setLoading(true);
    setReservation(null);

    if (!reservationId) {
      showToast("danger", "Lien invalide: identifiant manquant.");
      setLoading(false);
      return;
    }

    try {
      const url = `${process.env.REACT_APP_BAC_URL}/mail/reservation`;

      const payload = {
        reservationId,
        headers: "true",
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: "bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.status === 200 && result?.data) {
        // Normalisation optionnelle: si backend renvoie "state" -> "status"
        const normalized = {
          ...result.data,
          status: result.data.status ?? result.data.state,
        };

        setReservation(normalized);
      } else {
        showToast(
          "danger",
          "Consultation impossible: réservation introuvable.",
        );
      }
    } catch (err) {
      showToast(
        "danger",
        "Erreur réseau: impossible de charger la réservation.",
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getReservation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationId]);

  return (
    <div className="admin-page">
      <Container className="admin-shell">
        {/* Topbar */}
        <div className="admin-topbar">
          <img className="admin-logo" alt="Logo" src={logo} />
        </div>

        {/* Loading */}
        {loading && (
          <div className="admin-card">
            <h3 className="admin-title">Chargement de votre réservation</h3>
            <p className="admin-subtitle">
              Merci de patienter quelques instants.
            </p>
            <div className="d-flex align-items-center gap-2 mt-3">
              <Spinner animation="border" size="sm" />
              <span>Récupération des informations…</span>
            </div>
          </div>
        )}

        {/* Error / Not found */}
        {!loading && !reservation && (
          <div className="admin-card">
            <h3 className="admin-title">Consultation impossible</h3>
            <p className="admin-subtitle">
              Une erreur s’est produite ou la réservation n’existe pas. Si le
              problème persiste, veuillez nous contacter.
            </p>

            <div className="d-flex gap-2 flex-wrap mt-3">
              <Button
                className="btn-primary-gold"
                onClick={getReservation}
                type="button"
              >
                Réessayer
              </Button>
              <Button
                variant="outline-secondary"
                onClick={goHome}
                type="button"
              >
                Retour à l’accueil
              </Button>
            </div>
          </div>
        )}

        {/* Success → Modal Recap */}
        {!loading && reservation && <RecapResa reservationList={reservation} />}
      </Container>

      <ToastContainer position="bottom-end" className="p-3">
        <Toast
          show={toast.show}
          onClose={() => setToast((t) => ({ ...t, show: false }))}
          delay={3000}
          autohide
          bg={toast.variant}
        >
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
